export default __webpack_public_path__ + "static/media/veneko.48f62c55.png";